import { TextVariants } from "@src/straps/base/type/Text/Text";
import { ProjectType } from "@src/types";
import StatusNode from "./StatusNode";
import { projectCategoryRenderingValues } from "../projectRenderingOptions";

export default function ProjectCategoryNode({
  projectType,
  textVariant,
}: {
  readonly projectType: ProjectType;
  readonly textVariant?: TextVariants;
}) {
  const { color, title } = projectCategoryRenderingValues[projectType];
  return (
    <StatusNode
      icon="dot-closed"
      iconColor={color}
      title={title}
      smallIcon
      textVariant={textVariant}
      dataTestId="project-category-node"
    />
  );
}
